import { getUUID } from '@/lib';
import { Ref, useRef } from 'react';
import styles from './StanCheckbox.module.css';
import { StanCheckboxProp } from '../types';
import { StanLabel } from '../StanLabel/StanLabel';
import { cn } from '@/lib/utils/cn';

interface StanCheckboxPropsWithRef extends StanCheckboxProp {
    ref?: Ref<HTMLInputElement>;
}

export const StanCheckbox = ({
    id = getUUID(),
    checked = false,
    loading = false,
    disabled = false,
    indeterminate = false,
    error = false,
    label,
    caption,
    placement = 'right',
    onChange,
    ref,
}: StanCheckboxPropsWithRef) => {
    // Create internal fallback ref
    const internalRef = useRef<HTMLInputElement>(null);

    // Use forwarded ref if provided, else fallback to internalRef
    const resolvedRef = (ref as React.RefObject<HTMLInputElement>) || internalRef;

    const getVariantClass = () => {
        return disabled
            ? checked
                ? indeterminate
                    ? styles.disabledMinusIcon
                    : styles.disabledCheckIcon
                : ''
            : checked
              ? indeterminate
                  ? styles.minusIcon
                  : styles.checkIcon
              : '';
    };

    const checkboxClasses = `${styles.checkbox} ${getVariantClass()}`.trim();

    return (
        <div className={styles.container}>
            {label && placement === 'right' && <StanLabel label={label} caption={caption} />}
            <label
                className={cn(
                    styles.checkboxContainer,
                    disabled && styles.disabled,
                    loading && styles.loading,
                    error && styles.error,
                    !disabled && !loading ? styles.default : ''
                )}
            >
                <input
                    ref={resolvedRef}
                    id={id}
                    className={styles.hiddenCheckbox}
                    type='checkbox'
                    checked={checked}
                    disabled={loading || disabled}
                    onChange={onChange}
                />
                <span className={checkboxClasses} />
            </label>
            {label && placement === 'left' && <StanLabel label={label} caption={caption} />}
        </div>
    );
};

StanCheckbox.displayName = 'StanCheckbox';
